import { render, staticRenderFns } from "./Document_details.vue?vue&type=template&id=3db38d8c&scoped=true&"
import script from "./Document_details.vue?vue&type=script&lang=js&"
export * from "./Document_details.vue?vue&type=script&lang=js&"
import style0 from "./Document_details.vue?vue&type=style&index=0&id=3db38d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db38d8c",
  null
  
)

export default component.exports